import { getURL } from "../getURL";
import { router } from "../router/imperative-api";
var redirect = function redirect2(path, status) {
  if (process.env.VITE_ENVIRONMENT !== "ssr") {
    router.navigate(path);
    return;
  }
  var finalPath = path[0] === "/" ? `${getURL()}${path}` : path;
  return Response.redirect(finalPath, status);
};
export {
  redirect
};
//# sourceMappingURL=redirect.js.map
